exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-pie.js
// module id = 55
// module chunks = 0